import {ChangeDetectorRef, Component, forwardRef, HostListener} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractSwitchInput} from "../abstract-switch-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIEditSwitchInputComponent),
            multi: true
        }
    ],
    selector: "fui-edit-switch-input",
    styleUrls: ["./edit-switch-input.component.scss"],
    templateUrl: "./edit-switch-input.component.html"
})
export class FUIEditSwitchInputComponent extends FUIAbstractSwitchInput {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }
}
